/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntityType } from './EntityType';
import {
    EntityTypeFromJSON,
    EntityTypeFromJSONTyped,
    EntityTypeToJSON,
    EntityTypeToJSONTyped,
} from './EntityType';
import type { TrackEvent } from './TrackEvent';
import {
    TrackEventFromJSON,
    TrackEventFromJSONTyped,
    TrackEventToJSON,
    TrackEventToJSONTyped,
} from './TrackEvent';
import type { TrackSurface } from './TrackSurface';
import {
    TrackSurfaceFromJSON,
    TrackSurfaceFromJSONTyped,
    TrackSurfaceToJSON,
    TrackSurfaceToJSONTyped,
} from './TrackSurface';

/**
 * 
 * @export
 * @interface TrackPlatformEventRequest
 */
export interface TrackPlatformEventRequest {
    /**
     * 
     * @type {EntityType}
     * @memberof TrackPlatformEventRequest
     */
    entityType: EntityType;
    /**
     * MongoDB ObjectId of the tracked entity
     * @type {string}
     * @memberof TrackPlatformEventRequest
     */
    entityId: string;
    /**
     * 
     * @type {TrackEvent}
     * @memberof TrackPlatformEventRequest
     */
    event: TrackEvent;
    /**
     * 
     * @type {TrackSurface}
     * @memberof TrackPlatformEventRequest
     */
    surface: TrackSurface;
    /**
     * Frontend-generated per-session UUID for journey stitching
     * @type {string}
     * @memberof TrackPlatformEventRequest
     */
    sessionId?: string;
}



/**
 * Check if a given object implements the TrackPlatformEventRequest interface.
 */
export function instanceOfTrackPlatformEventRequest(value: object): value is TrackPlatformEventRequest {
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('entityId' in value) || value['entityId'] === undefined) return false;
    if (!('event' in value) || value['event'] === undefined) return false;
    if (!('surface' in value) || value['surface'] === undefined) return false;
    return true;
}

export function TrackPlatformEventRequestFromJSON(json: any): TrackPlatformEventRequest {
    return TrackPlatformEventRequestFromJSONTyped(json, false);
}

export function TrackPlatformEventRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackPlatformEventRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'entityType': EntityTypeFromJSON(json['entityType']),
        'entityId': json['entityId'],
        'event': TrackEventFromJSON(json['event']),
        'surface': TrackSurfaceFromJSON(json['surface']),
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
    };
}

export function TrackPlatformEventRequestToJSON(json: any): TrackPlatformEventRequest {
    return TrackPlatformEventRequestToJSONTyped(json, false);
}

export function TrackPlatformEventRequestToJSONTyped(value?: TrackPlatformEventRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityType': EntityTypeToJSON(value['entityType']),
        'entityId': value['entityId'],
        'event': TrackEventToJSON(value['event']),
        'surface': TrackSurfaceToJSON(value['surface']),
        'sessionId': value['sessionId'],
    };
}

